import { Component, OnDestroy, OnInit } from '@angular/core';
import { PortfolioService, StorageService, VariablesService } from '../../../shared/services';
import { Subscription, timer } from 'rxjs';
import { transition, trigger, useAnimation } from '@angular/animations';
import { fadeIn, fadeOut } from 'ng-animate';

@Component({
  selector: 'app-sip-ticker',
  templateUrl: './sip-ticker.component.html',
  styleUrls: ['./sip-ticker.component.scss'],
  animations: [
    trigger('animateTickr', [
      transition(':enter', [useAnimation(fadeIn, {
        params: { timing: 0.3 }
      })]),
      transition(':leave', [useAnimation(fadeOut, {
        params: { timing: 0.3 }
      })])
    ])
  ],
})
export class SipTickerComponent implements OnInit, OnDestroy {

  data;
  donor;
  iplocationObj;
  ticker_shown;
  subs: Subscription[] = [];

  constructor(
    private portfolioService: PortfolioService,
    public vars: VariablesService,
    public storageService: StorageService
  ) { }

  ngOnInit() {
    if (!this.storageService.getFromSession('ticker_shown')) {
      this.subs.push(this.vars.clientLocationData.subscribe(resp => {
        if (resp) {
          this.iplocationObj = resp;
          this.getSipTickrData();
        }
      }));
      this.storageService.addSessionData('ticker_shown', 'true');
    } else {
      this.ticker_shown = true;
    }
  }

  getSipTickrData() {
    this.portfolioService.getTickrData({ country_code: this.iplocationObj?.country_code }).subscribe((res: any) => {
      this.data = res.data;
      this.setTickrInterval();
    });
  }

  setTickrInterval() {
    let index = 0;
    const timer$ = timer(5000, 10000);
    timer$.subscribe((res => {
      this.donor = this.data[index];
      index += 1;
      setTimeout(() => this.donor = null, 4000);
    }));
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }
}
